<script setup>
const MobileMenu = defineAsyncComponent(
  () => import("./components/MobileMenu.vue")
)

const AppHeader = defineAsyncComponent(
  () => import("./components/AppHeader.vue")
)

const { injectSkinClasses } = useSkins()
const store = useAuthStore()
const { openAuthDialog } = useAuthDialog()

const handleRegister = () => {
  if (store.authStore.token) {
    navigateTo({ name: "user-profile-company-registration" })
    return
  }
  openAuthDialog("/user-profile/company-registration")
}

// ℹ️ This will inject classes in body tag for accurate styling
injectSkinClasses()
</script>

<template>
  <div class="layout-wrapper layout-blank">
    <div class="parent-wrapper">
      <AppHeader @register="handleRegister" />

      <div class="slot-parent">
        <slot />
      </div>

      <MobileMenu />
      <AppAuthDialog />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.layout-wrapper.layout-blank {
  width: 100%;
  min-width: 100%;
  min-height: 100vh;
  align-items: stretch;
  flex-direction: column;
  background: #f5f4f9;
}
.parent-wrapper {
  width: min(
    calc(100% - (2 * var(--client-app-gutter, 24px))),
    var(--client-app-max-width, 750px)
  );
  min-height: 100vh;
  margin: 0 auto;
  background: rgb(var(--v-theme-background));
  box-shadow: 0 0 34px rgba(31, 26, 54, 0.07);
}

.slot-parent {
  margin-bottom: 75px;
}

@media (max-width: 599px) {
  .parent-wrapper {
    width: 100%;
    box-shadow: none;
  }
}
</style>
